import { Routes } from '@angular/router';
import { MainComponent } from './containers/main/main.component';
import { EditWebsiteComponent } from './containers/edit-website/edit-website.component';

export const ECOM_ROUTES: Routes = [
  {
    path: '',
    component: MainComponent,
  },
  {
    path: 'websites/:id',
    component: EditWebsiteComponent,
  },
  {
    path: 'websites',
    component: EditWebsiteComponent,
  },
];
